Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFlickrLoad = exports.flickrClassNames = void 0;
var _utils = require("../../utils");
var isFlickrScriptAdded = false;
var flickrClassNames = [".flickr-embed"].join(",");
exports.flickrClassNames = flickrClassNames;
var flickrEmbedUrl = "https://embedr.flickr.com/assets/client-code.js";
var handleFlickrLoad = function handleFlickrLoad() {
  if (document.querySelector(flickrClassNames) !== null) {
    if (!isFlickrScriptAdded) {
      (0, _utils.createScriptTag)(flickrEmbedUrl, null);
      isFlickrScriptAdded = true;
      return {
        status: 'createScriptTag'
      };
    }
  }
  return {
    status: 'null'
  };
};
exports.handleFlickrLoad = handleFlickrLoad;